import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "page-header__left" }
const _hoisted_2 = { class: "page-header__title" }
const _hoisted_3 = {
  key: 0,
  class: "page-header__subtitle"
}
const _hoisted_4 = {
  key: 0,
  class: "page-header__actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page-header", [
      _ctx.sizeClass,
      {
        'page-header--divider': _ctx.divider,
      },
    ]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "title", {}, () => [
          _createTextVNode(_toDisplayString(_ctx.title), 1)
        ], true)
      ]),
      (_ctx.subtitle || _ctx.$slots.subtitle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "subtitle", {}, () => [
              _createTextVNode(_toDisplayString(_ctx.subtitle), 1)
            ], true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.$slots.actions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "actions", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}